<template>
  <g fill="inherit">
    <path
      d="M9.29673 8.28597L10.34 18.8277C10.3673 18.9921 10.5792 19.0422 10.6768 18.9068L12.6746 16.116C12.7538 16.0052 12.92 16.014 12.9885 16.1309L14.972 19.4177C15.0238 19.5074 15.139 19.5373 15.2287 19.4845L16.3402 18.8277C16.4299 18.7749 16.4589 18.6588 16.4052 18.57L14.3005 15.2526C14.2284 15.133 14.3084 14.9792 14.4473 14.9695L18.0736 14.7145C18.2406 14.7031 18.3092 14.4938 18.1817 14.3856L9.60266 8.11373C9.46989 8.00118 9.26859 8.1145 9.29673 8.28597Z"
      fill="inherit"
    />
    <path
      d="M8.57801 13.6599H3.05053C2.22397 13.6599 1.55218 12.9881 1.55218 12.1616V3.17219C1.55218 2.34563 2.22399 1.67384 3.05053 1.67384H13.0387C13.8653 1.67384 14.5371 2.34565 14.5371 3.17219V9.75294L15.536 10.6024L15.5351 3.17206C15.5351 1.79504 14.4157 0.674734 13.0378 0.674734H3.05049C1.67347 0.674734 0.553162 1.79412 0.553162 3.17206V12.1614C0.553162 13.5385 1.67255 14.6588 3.05049 14.6588H8.74139L8.57801 13.6599Z"
      fill="inherit"
    />
  </g>
</template>

<script>
export default {
  name: 'icon-select',
}
</script>
